<div class="row mt-5">
  <div class="col-6 col-lg-3">
    <div class="mb-3">
      <label class="texto-titulo" for="slctContatoResponsavel">CONTATO DO RESPONSÁVEL <a style="color: red;">*</a></label>
      <app-select
        [value]="form.contatoSelecionado"
        (valueChanges)="form.contatoSelecionado = $event"
        name="contatoSelecionado"
        id="slctContatoResponsavel"
        [options]="form.contatos"
        optionValue="idContato"
        optionText="nome"
        defaultDescription="SELECIONE"
        defaultValue="0"
        [ngClass]="{ 'is-invalid': form.contatoSelecionadoError }"
        (change)="form.onContatoSelecionado()">
      </app-select>
      <field-error [isError]="form.contatoSelecionadoError" message="Contato responsável obrigatório"></field-error>
    </div>
  </div>

  @if (form.prePago) {
    <div class="col-6 col-lg-3">
      <div class="mb-3">
        <label class="texto-titulo" for="inptDataPagamento">DATA DE PAGAMENTO <a style="color: red;">*</a></label>
        <input class="form-control" id="inptDataPagamento"
          [ngModel]="form.dataPagamento" (ngModelChange)="form.dataPagamento = $event"
          [ngClass]="{ 'is-invalid': form.dataPagamentoError }"
          placeholder="dd/mm/aaaa" dateMask [matDatepicker]="picker1"
          (change)="form.onDataPagamento()" (dateChange)="form.onDataPagamento()">
        <mat-datepicker-toggle matSuffix [for]="picker1" [ngClass]="{ 'datepicker-error-custom': form.dataPagamentoError }" class="datepicker-custom"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <field-error [isError]="form.dataPagamentoError" [message]="form.dataPagamentoMessageError"></field-error>
      </div>
    </div>
  }
  @if (!form.prePago) {
    <div class="col-6 col-lg-3"></div>
  }

  <div class="col-6 col-lg-3">
    <div class="mb-3">
      <label class="texto-titulo" for="inptDataInicial">PERÍODO DE UTILIZAÇÃO (inicial) <a style="color: red;">*</a></label>
      <input class="form-control" id="inptDataInicial"
        [ngModel]="form.dataInicialPedido" (ngModelChange)="form.dataInicialPedido = $event"
        [ngClass]="{ 'is-invalid': form.dataInicialError }"
        placeholder="dd/mm/aaaa" dateMask [matDatepicker]="picker2"
        (change)="form.onDataInicialPedido()" (dateChange)="form.onDataInicialPedido()">
      <mat-datepicker-toggle matSuffix [for]="picker2" [ngClass]="{ 'datepicker-error-custom': form.dataInicialError }" class="datepicker-custom"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      <field-error [isError]="form.dataInicialError" [message]="form.dataInicialMessageError"></field-error>
    </div>
  </div>

  <div class="col-6 col-lg-3">
    <div class="mb-3">
      <label class="texto-titulo" for="inptDataFinal">PERÍODO DE UTILIZAÇÃO (final) <a style="color: red;">*</a></label>
      <input class="form-control" id="inptDataFinal"
        [ngModel]="form.dataFinalPedido" (ngModelChange)="form.dataFinalPedido = $event"
        [ngClass]="{ 'is-invalid': form.dataFinalError }"
        placeholder="dd/mm/aaaa" dateMask [matDatepicker]="picker3"
        (change)="form.onDataFinalPedido()" (dateChange)="form.onDataFinalPedido()">
      <mat-datepicker-toggle matSuffix [for]="picker3" [ngClass]="{ 'datepicker-error-custom': form.dataFinalError }" class="datepicker-custom"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
      <field-error [isError]="form.dataFinalError" [message]="form.dataFinalMessageError"></field-error>
    </div>
  </div>
</div>

<div class="row mt-4">
  <div class="col-6 col-lg-4">
    <div class="mb-4">
      <label class="texto-titulo" for="slctOrdemEnvelopes">ORDEM DOS ENVELOPES/RECIBOS <a style="color: red;">*&nbsp;&nbsp;</a></label>
      <i class="fa fa-info-circle c-black fa-1x icone-padrao" aria-hidden="true"
        [popover]="myPopoverEnvelopes" popoverTitle="Ordenação de envelopes"
      popoverPlacement="top" triggers="click" [outsideClick]="true"></i>
      <ng-template #myPopoverEnvelopes>
        <span>Escolha o tipo de ordenação para os envelopes.</span>
      </ng-template>
      <div class="mb-3">
        <app-select
          [ngClass]="{ 'is-invalid': form.departamentoError }"
          [value]="form.ordemEnvelopes"
          (valueChanges)="form.ordemEnvelopes = $event"
          name="ordemEnvelopesName"
          id="slctOrdemEnvelopes"
          [options]="[
            {name: 'NOME DO USUÁRIO', value: 'N'},
            {name: 'MATRICULA DO USUÁRIO', value: 'M'},
            {name: 'DEPARTAMENTO E NOME DO USUÁRIO', value: 'D'},
            {name: 'DEPARTAMENTO E MATRICULA DO USUÁRIO', value: 'P'}
          ]"
          optionValue="value"
          optionText="name"
          defaultDescription="NOME DO USUÁRIO"
          defaultValue="N">
        </app-select>
      </div>
    </div>
  </div>

  <div class="col-6 col-lg">
    <div class="mb-4">
      <label class="texto-titulo" for="inptEmailConfirmacao">E-MAIL PARA CONFIRMAÇÃO <a style="color: red;">*</a></label>
      <input type="email" class="form-control" id="inptEmailConfirmacao"
        aria-describedby="emailHelp" placeholder="Alelo@Alelo.com"
        [ngModel]="form.emailConfirmacao" (ngModelChange)="form.emailConfirmacao = $event"
        (blur)="form.onEmailConfirmacao()"
        [ngClass]="{ 'is-invalid': form.emailValidacaoError }" required>
      <field-error [isError]="form.emailValidacaoError" message="Email Inválido"></field-error>
    </div>
  </div>

  <div class="col-6 col-lg">
    <div class="mb-4">
      <label class="texto-titulo" for="inptEmailNfe1">E-MAIL PARA ENVIO DA NF(1) <a style="color: red;">*</a></label>
      <input type="email" class="form-control" id="inptEmailNfe1"
        aria-describedby="emailHelp" placeholder="Alelo@alelo.com"
        [ngModel]="form.emailNfe1" (ngModelChange)="form.emailNfe1 = $event"
        (blur)="form.onEmailNfe1()"
        [ngClass]="{ 'is-invalid': form.emailNfe1Error }">
      <field-error [isError]="form.emailNfe1Error" message="Email Inválido"></field-error>
    </div>
  </div>

  <div class="col-6 col-lg">
    <div class="mb-3">
      <label class="texto-titulo" for="inptEmailNfe2">E-MAIL PARA ENVIO DA NF(2) <a style="color: red;">*</a></label>
      <input type="email" class="form-control" id="inptEmailNfe2"
        aria-describedby="emailHelp" placeholder="Alelo@alelo.com"
        [ngModel]="form.emailNfe2" (ngModelChange)="form.emailNfe2 = $event"
        (blur)="form.onEmailNfe2()"
        [ngClass]="{ 'is-invalid': form.emailNfe2Error }">
      <field-error [isError]="form.emailNfe2Error" message="Email Inválido"></field-error>
    </div>
  </div>
</div>
